import cloneDeep from 'lodash/cloneDeep'

export const INIT_LOGIN_DATA = {
  lang: '',
  logined: window.inSDK,
  gamePlayer: {
    playerId: '',
    serverId: '',
    playerName: '',
  } as GamePlayer,
  sdkConfig: {
    appLang: '',
    appId: window.appId,
    clientVersion: '',
    deviceId: '',
    platform: '',
  } as SdkConfig,
  userInfo: {
    lang: '',
    userId: '',
    sessionId: '',
    playerId: '',
    playerType: 1,
    zoneId: 0 as Zone['zoneId'],
    serverId: '',
    serverName: '',
    playerName: '',
    checked: 0,
    isBinded: false,
    isCodeBinded: false,
  } as UserInfo,
}

export const login = cloneDeep(INIT_LOGIN_DATA)
